import React, { useState, useEffect, useLayoutEffect } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import SlickSlider from 'react-slick';
import { v4 as uuidv4 } from 'uuid';
import PSignupForm from './common/PSignupForm';
import PLoginForm from './common/PLoginForm';
import PReverifyForm from './common/PReverifyForm';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { RECAPTCHA_SITE_KEY } from './utils/constants';
import {
    GoogleReCaptchaProvider
} from 'react-google-recaptcha-v3';

import Logo from './images/logos/logo-12.png';
import iPhonePic from './images/iphone-pic.png';
import Slider1 from './images/iphone-slider/slider-1.png';
import Slider2 from './images/iphone-slider/slider-2.jpg';
import Slider3 from './images/iphone-slider/slider-3.jpg';
import Slider4 from './images/iphone-slider/slider-4.jpg';
import Slider5 from './images/iphone-slider/slider-5.jpg';
import Slider6 from './images/iphone-slider/slider-6.jpg';
import LogoV2 from './images/login-header.png';

const RegisterPage = () => {
    const [signupFormStatus, setSignupFormStatus] = useState(false);
    const [show, setShow] = useState('signup');
    const [reverifyData, setReverifyData] = useState(null);
    const [sourcePath, setSourcePath] = useState('');
    const history = useHistory();
    const isLoggedIn = localStorage.getItem('loggedin_user');
    const location = useLocation();

    useEffect(() => {
        if (signupFormStatus) {
            if (sourcePath == '/register' || sourcePath == '/login') {
                window.location = '/become-creator';
            } else {
                window.location = '/edit-profile';
            }
        }
    }, [signupFormStatus]);

    useLayoutEffect(() => {
        document.querySelector("html").classList.add("root-register");

        return () => {
            document.querySelector("html").classList.remove("root-register");
        };
    }, [location]);

    useEffect(() => {
        const currentLocation = window.location.pathname;
        setSourcePath(currentLocation);
    }, []);

    const settings = {
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        adaptiveHeight: true,
        autoplay: true,
        autoplaySpeed: 5000,
    };

    const sliderImages = [Slider2, Slider1, Slider3, Slider4, Slider5, Slider6];

    if (isLoggedIn) {
        history.push('/home');
    }

    return (
        <div className="register-container container mb-4">
            <div className="section page-title" />

            <div className="row">
                <div className="col-md-6">
                    <div className="iphone-slider-container">
                        <div className="iphone-pic">
                            <LazyLoadImage src={iPhonePic} alt="iPhone" />
                        </div>
                        <div className="iphone-slider">
                            <SlickSlider {...settings}>
                                {sliderImages.map((sliderImage, key) => <div className="iphone-slider-item" key={uuidv4()}><LazyLoadImage src={sliderImage} alt={`priva-${key}`} /></div>)}
                            </SlickSlider>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className={"register-info-container" + `${show === 'signup' ? ' register-page-container' : ''}`}>
                        <div className="register-logo">
                            <Link to="/"><LazyLoadImage src={LogoV2} alt="Register" /></Link>
                            <span>Premium Subscription-based Social Media Platform</span>
                        </div>
                        <div className="text-center">
                            {
                                show !== 'reverify'
                                    ?
                                    <div className="login-tabs">
                                        <span
                                            className={`${show == 'login' ? 'active' : ''}`}
                                            onClick={() => setShow('login')}
                                        >
                                            Login
                                        </span>
                                        <span
                                            className={`${show == 'signup' ? 'active' : ''}`}
                                            onClick={() => setShow('signup')}
                                            style={{
                                                marginLeft: 4
                                            }}
                                        >
                                            Sign Up
                                        </span>
                                    </div>
                                    : <div class="reverify-message">
                                        <p>
                                            As part of our ongoing security measures we require you to verify your email address. You may keep your current email or update it.
                                        </p>
                                    </div>
                            }

                            <div className="register-form-cntainer">
                                <GoogleReCaptchaProvider
                                    language="en"
                                    useRecaptchaNet="true"
                                    reCaptchaKey={RECAPTCHA_SITE_KEY}
                                    scriptProps={{
                                        defer: true, // optional, default to false
                                        appendTo: 'body', // optional, default to "head", can be "head" or "body",
                                    }}
                                >
                                    {
                                        show === 'signup'
                                            ? <PSignupForm setSignupFormStatus={setSignupFormStatus} setShow={setShow} />
                                            : (
                                                show === 'login'
                                                    ? <PLoginForm setShow={setShow} setReverifyData={setReverifyData} />
                                                    : <PReverifyForm setShow={setShow} reverifyData={reverifyData} setReverifyData={setReverifyData} />
                                            )

                                    }

                                    {/* <div className='recaptcha-lbl'>
                                        This site is protected by reCAPTCHA and the Google{' '}
                                        <a href="https://policies.google.com/privacy">Privacy Policy</a> and{' '}
                                        <a href="https://policies.google.com/terms">Terms of Service</a> apply.
                                    </div> */}
                                </GoogleReCaptchaProvider>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RegisterPage;
